<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>轮播图管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div class="search-line clearfix">
          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showAddWindow('add')"
          >新建</div>
        </div>
      </div>
      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">标题</th>
              <th class="itemStatus">状态</th>
              <th class="itemStatus">轮播图</th>
              <th
                class="action"
                width="130"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in tableData"
              :key="item.id"
            >
              <td class="itemStatus">{{item.title}}</td>
              <td :class="'itemStatus itemStatus' + item.status">{{ item.status == 1 ? '已发布' : '未发布' }}</td>
              <td class="itemStatus">
                <img
                  :src="item.imgPath"
                  :onerror="$store.state.defaultImg"
                >
              </td>
              <td class="action">
                <a
                  v-if="item.status==1"
                  class="nopublish"
                  href="javascript:;"
                  @click="unpublish(item.id)"
                >取消发布</a>
                <a
                  v-if="item.status==0"
                  class="publish"
                  href="javascript:;"
                  @click="publish(item.id)"
                >发布</a>
                <a
                  class="edit"
                  href="javascript:;"
                  @click="querySingle(item.id)"
                >编辑</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="askDelete(item.id)"
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="false"
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
      <!-- 轮播图添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">添加/编辑轮播图</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"><i class="require">*</i>标题:</span>
                <input
                  type="text"
                  v-model="formInfo.title"
                  maxlength="25"
                >
              </div>
              <div class="item">
                <span class="label">图片大小:</span>
                <div>1920px * 600px</div>
              </div>
              <div class="item">
                <span class="label"><i class="require">*</i>轮播图片:</span>
                <div class="item-box">
                  <input
                    type="text"
                    id="imgurl"
                    disabled="disabled"
                    v-model="formInfo.imgPath"
                  >
                  <span
                    class="button"
                    id="uploadImg"
                    @click="showImageWindow"
                  >添加图片</span>
                </div>
              </div>
              <div class="item">
                <div id="preview"></div>
              </div>
              <div class="item">
                <span class="label"><i class="require"></i>是否立即发布:</span>
                <div class="k-container col1">
                  <label class="check-label">
                    <input
                      class="elevel"
                      type="radio"
                      v-model="formInfo.status"
                      value="1"
                    >是</label>
                  <label class="check-label">
                    <input
                      class="elevel"
                      type="radio"
                      v-model="formInfo.status"
                      value="0"
                      checked="checked"
                    >否</label>
                </div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        id="dialog_overlay"
        class=""
        :style="classShowImageWindow"
      >
        <div id="dialog_bg"></div>
        <div
          id="dialog_panel"
          style="margin-left: -137px; margin-top: -84px;"
          class=""
        >
          <div id="dialog_panel_bg"></div>
          <div id="dialog_title">选择图片</div>
          <div id="dialog_content">
            <div
              class="imgType"
              style="margin-bottom:10px;"
              id="imgType"
            >允许上传的图片格式：jpg</div>
            <div
              id="thumbPreview"
              v-show="showImgPreview"
            ><img
                ref="headImg"
                :onerror="$store.state.defaultImg"
              ></div>
            <div>
              <input
                id="imageFile"
                type="file"
                accept=".jpg"
                ref="imageFile"
                @change="imageFileChange"
              >
            </div>
          </div>
          <div id="dialog_control">
            <a
              href="javascript:void(0)"
              @click="hideImageWindow"
              id="dialog_close"
              class="button"
              style="display: inline-block;"
            >取消</a>
            <a
              href="javascript:void(0)"
              @click="confirmImage"
              id="dialog_ok"
              class="button"
              style="display: inline-block;"
            >确认</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'User',
  components: {
    Pagination
  },
  data() {
    return {
      classShowAddWindow: {},
      tableData: [],
      queryInfo: {
        page: 1,
        size: 10,
        position: '',
        status: '',
        title: ''
      },
      formInfo: {
        id: 0,
        title: '',
        imgPath: '',
        status: 0
      },
      showImgPreview: false,
      tableDataCount: 0,
      uploadedCsv: '',
      classShowImageWindow: {}
    }
  },
  methods: {

    formTableImageSrc(src) {
      if (src !== '') {
        return src
      } else {
        return ''
      }
    },
    showImageWindow() {
      this.classShowImageWindow = {
        visibility: 'visible'
      }
    },
    hideImageWindow() {
      this.classShowImageWindow = {}
    },
    async imageFileChange() {
      const uploadUrl = '/info_files/' + this.$refs.imageFile.files[0].name
      var that = this
      var f = this.$refs.imageFile.files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        var image = new Image()
        image.onload = function() {
          var width = image.width
          var height = image.height
          if (width !== 1920 && height !== 600) {
            that.$layer.msg('文件尺寸应为：1920*600（像素）！')
            that.uploaded_img = ''
            that.showImgPreview = false
            that.$refs.headImg.src = ''
            that.$refs.imageFile.value = ''
            return false
          } else {
            that.$http.put(uploadUrl, that.$refs.imageFile.files[0]).then((data) => {
              that.uploaded_img = data
              that.showImgPreview = true
              that.$refs.headImg.src = data
            }).catch(() => {
              that.$layer.msg('上传失败！')
            })
          }
        }
        image.src = data // img.src 应该是放在 onload 方法后边的, 因为当image的src发生改变，浏览器就会跑去加载这个src里的资源,先告诉浏览器图片加载完要怎么处理，再让它去加载图片
      }
      reader.readAsDataURL(f)
    },

    confirmImage() {
      this.formInfo.imgPath = this.uploaded_img
      this.hideImageWindow()
    },
    // 保存
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$parent.showMsg('请输入标题!')
        return false
      }
      if (!this.formInfo.imgPath) {
        this.$parent.showMsg('请选择轮播图片!')
        return false
      }

      if (this.formInfo.id) {
        const url = '/flash/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        await this.$http.post('/flash/', this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 搜索
    async search() {
      await this.$http.get('/flash/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$parent.showMsg('获取轮播信息失败！')
      })
    },
    async xlsChange() {
      const uploadUrl = '/files/' + this.$refs.xlsFile.files[0].name
      await this.$http.put(uploadUrl, this.$refs.xlsFile.files[0]).then((data) => {
        this.uploadedCsv = data
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },

    // 打开用户添加/编辑弹窗
    showAddWindow(value) {
      if (value === 'add') {
        this.formInfo = {
          id: 0,
          title: '',
          imgPath: '',
          status: 0
        }
      }
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭用户添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
    },
    unpublish(id) {
      this.$parent.showConfirm('确定要取消发布吗？', () => {
        this.askRelease(id, 0)
      })
    },
    publish(id) {
      this.$parent.showConfirm('确定要发布吗？', () => {
        this.askRelease(id, 1)
      })
    },
    // 发布
    async askRelease(id, status) {
      const msg = status === 0 ? '取消' : ''
      await this.$http.post('/flash_pub/', {
        id: id,
        status: status
      }).then((data) => {
        this.$parent.showMsg(msg + '发布成功！')
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg(msg + '发布失败！')
      })
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/flash/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: id,
          title: data.title,
          imgPath: data.imgPath,
          status: data.status
        }
        this.showAddWindow('edit')
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    async askDelete(id) {
      const url = '/flash/' + id + '/'
      await this.$http.put(url, {
        isdel: 1
      }).then((data) => {
        this.$parent.showMsg('删除成功！')
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('删除失败！')
      })
    },
    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
.itemStatus img {
  width: 100px;
}
#dialog_overlay {
  z-index: 100;
}
</style>
